// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/diagnostics/MoveAssets/styles.css
// module id = 1888
// module chunks = 0